export default {
    type: 'person-departments',
    aliases: {
        camel: 'personDepartments',
        singular: 'Person department',
        plural: 'Person departments',
        lowerSingular: 'person department',
        lowerPlural: 'person departments',
    },
    publishable: false,
    adminSection: null,
    componentType: 'pivot',
    components: {}
};
